import { useContext } from "react";

import { StoreLocatorContext } from "../contexts/store-locator";

export function useStoreLocator() {
  return useContext(StoreLocatorContext)!;
}
